import { getNblyApiHeaders } from "../api/getNblyApiHeaders";
import { apiConfig } from "../config";
import { start_loader } from "./start_loader";
import { stop_loader } from "./stop_loader";

export function diagnoseFeeMRA(){
    var weblocationId = window.objOSGlobal.requestBodyValues.WebLocationId;
        // $('.diagnoseFee').removeClass("hidden");        
         start_loader();
        $.ajax({
            url: apiConfig.franchiseWebLocationProfileFees + weblocationId + '?apikey=' + window.DEFINE_VALUE.JS_API_KEY+"&"+getNblyApiHeaders(),
            dataType: 'json',
            type: 'GET',
            success: function (data: any)
            {
                stop_loader();
                let resultArray = data;
                $.each(resultArray, function (index: any, resultArray: any)
                { 
                if (resultArray?.defaultFee !=='' && resultArray?.defaultFee !=='null' && resultArray?.defaultFee !==0){
                    if (resultArray.name !== null && resultArray.name !== undefined 
                        && resultArray.name.toLocaleLowerCase() == "diagnostic fee"){
                        $('#sd-disclaimer-text').removeClass('hidden');
                        $('.dfee').text(resultArray.defaultFee);
                    }
                    else if(window.objOSGlobal.requestBodyValues.ConceptCode==="DVW" && resultArray.name !== null 
                        && resultArray.name !== undefined && resultArray.name.toLocaleLowerCase() == "inspection fee"){
                        $('.add-inspection-fee-sevicedetails').removeClass('hidden');
                        $('.add-inspection-fee-sevicedetails-fee').text(resultArray.defaultFee);
                    }
                } else{
                    $('.add-inspection-fee-sevicedetails').addClass('hidden');
                    $('#sd-disclaimer-text').addClass('hidden');
                }
                });

            }, error: function (e: any)
            {
                stop_loader();
                //console.log(e.message);
            }
        });
}